// --- Helper functions for type conversion ---
export const bufferToHex = (buffer)=>Array.from(new Uint8Array(buffer)).map((b)=>b.toString(16).padStart(2, '0')).join('');
export const hexToBuffer = (hex)=>{
    const cleanHex = hex.startsWith('0x') ? hex.slice(2) : hex;
    const match = cleanHex.match(/.{1,2}/g);
    return new Uint8Array(match ? match.map((byte)=>parseInt(byte, 16)) : []);
};
